// getBaseUrl.ts

const getBaseUrl = (): string => {
    const env = process.env.REACT_APP_ENV;

    switch (env) {
        case 'local':
            return 'http://localhost:3000'; // Local environment URL
        case 'development':
            return 'https://techforgov-dev.ignatiuz.com/'; // Development environment URL
        case 'production':
            return 'https://techforgov.ignatiuz.com/'; // Production environment URL
        default:
            throw new Error(`Unknown environment: ${env}`);
    }
};

export default getBaseUrl;  